<!-- Loading spinner -->
<!-- <div class="table-loading-shade" *ngIf="isLoaderActive">
  <mat-spinner class="mat-spinner-color"></mat-spinner>
</div> -->
<!-- /Loading spinner -->

<div class="back-white">
  <div class="row mx-0 py-2 align-items-center">
    <div class="col-md-4">
      <!-- <h5 class="mb-0"><strong>PDF Preview</strong></h5> -->
    </div>
    <div class="col-md-4 text-center">
      <h2 class="mb-0"><strong><u>PDF Preview</u></strong></h2>
    </div>
    <div class="col-md-4 text-right">
         <button mat-raised-button class="back-button me-2" (click)="convertToPDF()" *ngIf="!isDownloadingPdf && !isFranchisee">
      <mat-icon>cloud_download</mat-icon> Download PDF
    </button>
    <button mat-raised-button class="me-2" *ngIf="isDownloadingPdf && !isFranchisee" disabled>
      Downloading
    </button>
      <button mat-stroked-button class="back-button" (click)="back()">
        Back
      </button>
    </div>
  </div>
  <div class="pdf-container" #contentToConvert>
    <!-- Area Of House pdf  -->
    <div class="pdf-container-inner">
      <div class="pdf-header">
        <div>
          <img src="{{logo}}" alt="refresh-logo" />
        </div>
        <div class="labour">
          <p></p>
          <!-- <img class="icon22" src="../../../../resources/assets/img/icons8-home.svg" alt="" />
          <h5>Ordered By Area of House</h5> -->
        </div>
      </div>
      <!-- Loading spinner -->
      <!-- <div class="table-loading-shade" *ngIf="loading$ | async">
        <mat-spinner class="mat-spinner-color"></mat-spinner>
      </div> -->
      <!-- /Loading spinner -->
      <div class="component-container">
  
        <div class="">
          <div class="row">
            <div class="col-md-12">
              <h4 class="versions-heading font700 mb-0">Daily Log</h4>
            </div>
          </div>
          <div class="dl-detail mt-3">
            <div class="row">
              <div class="col-md-6">
                <h4 class="title"> <strong>Log Title :</strong> {{titleName}}</h4>
                <h6 class="title" *ngIf="titleDescription"> <strong>Description :</strong> {{titleDescription}}</h6>
              </div>
              <div class="col-md-6 text-right">
                <h6 class="title" *ngIf="created_by"> <strong>Created by :</strong> {{created_by}}</h6>
              </div>
            </div>
  
            <div class="outer_box">
              <div class="temp_box">
                <img *ngIf="icon" [src]="icon_url" class="icon_img">
                <!-- <app-image-viewer [images]="{{'[',,']'}}"
                  [idContainer]="'idOnHTML'" [loadOnInit]="true"></app-image-viewer> -->
                <!-- <lib-file-viewer [imageUrl]="icon_url"></lib-file-viewer> -->
                <div>
                  <h4 class="mb-0 mt-0" *ngIf="temperature" matTooltip="Actual Temperature">{{temperature}}&deg;C</h4>
                  <p class="mb-0 feels_like" *ngIf="feel_like_temp"  matTooltip="Feels like">{{feel_like_temp}}&deg;C</p>
                </div>
  
              </div>
              <div class="ext_details">
                <p *ngIf="location" matTooltip="Location" class="icon_para mb-0"><mat-icon
                    class="icon_location my-mat-icons">location_on</mat-icon>
                  {{location}}</p>
                <p *ngIf="wind_speed" matTooltip="Wind Speed" class="icon_para mb-0"><mat-icon
                    class="icon_wind_speed my-mat-icons">air</mat-icon>
                  {{wind_speed}}mph</p>
                <p *ngIf="humidity" matTooltip="Humidity" class="icon_para mb-0"><mat-icon
                    class="icon_humidity my-mat-icons">water_drop</mat-icon>
                  {{humidity}}%
                </p>
              </div>
            </div>
            <div class="row" *ngIf="weather_desc">
              <div class="col-md-12">
                <p class="mb-2"><strong>Weather Decription : </strong> {{weather_desc}}</p>
              </div>
            </div>
          </div>
  
  
          <div class="bids-container">
            <div class="dl-detail mt-3" *ngIf="photos?.length>0">
              <div class="text-center">
                  <h4 class="bg-upl">Attachments</h4>
              </div>
              <div class="grid grid-cols-6 gap-2" >
                  <div *ngFor="let photo of photos">
                      <div class="dl-images">
                          <img src="{{photo.file_path}}" class="h-32 w-full object-cover" alt="Image 1">
                          <mat-icon (click)="downloadFile(photo)">get_app</mat-icon>
                        </div>
                        <p class="mb-0 word-break-style">{{photo?.file_name}}</p>
                  </div>
                </div>
          </div>
            <!-- <div class="dl-detail mt-3" *ngIf="photos?.length>0">
              <div class="text-center">
                <h4 style="
                    background: #efefef;
                    padding: 8px;
                ">Attachments</h4>
              </div>
              <div fxLayout="flex row" fxLayoutGap="10px" class="">
                <div class="" fxFlex="19.2" *ngFor="let photo of photos">
                  <div class="dl-images">
                    <img height="140px" src="{{photo.file_path}}" alt="">
                    <mat-icon (click)="downloadFile(photo)">get_app</mat-icon>
                  </div>
                </div>
  
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
</div>